import { createSlice } from "@reduxjs/toolkit";

let fakeData = [
  {
    id: "acl-rule-001",
    sequenceNo: 10,
    policy: "Deny",
    protocol: "TCP",
    srcIpAddress: "192.168.1.0",
    srcPrefixLength: 24,
    srcPort: -1,
    dstIpAddress: null,
    dstPrefixLength: 32,
    dstPort: 22,
    description: "Block SSH access from guest network",
    version: 1,
  },
  {
    id: "acl-rule-002",
    sequenceNo: 20,
    policy: "Permit",
    protocol: "TCP",
    srcIpAddress: "10.0.0.0",
    srcPrefixLength: 8,
    srcPort: -1,
    dstIpAddress: "10.0.0.5",
    dstPrefixLength: 32,
    dstPort: 26,
    description: "Allow HTTP traffic to internal web servers",
    version: 1,
  },
  {
    id: "acl-rule-003",
    sequenceNo: 30,
    policy: "Permit",
    protocol: "UDP",
    srcIpAddress: "172.16.0.0",
    srcPrefixLength: 16,
    srcPort: -1,
    dstIpAddress: null,
    dstPrefixLength: 32,
    dstPort: 24,
    description: "Allow outbound DNS queries",
    version: 1,
  },
];

const initialState = {
  resource: "wiredIpAcls",
  data: [],
};

export const wiredIpv4AclSlice = createSlice({
  name: "wiredIpv4Acl",
  initialState,
  reducers: {
    setWiredIpv4AclData: (state) => {
      state.data = fakeData;
    },
    updateWiredIpv4AclData: (state, action) => {
      const payload = action.payload.data ?? action.payload;
      const createItems = payload.create ?? [];
      const updateItems = payload.update ?? [];
      const deleteIds = payload.delete?.ids ?? [];

      fakeData = fakeData
        .filter((item) => !deleteIds.includes(item.id))
        .map((item) => {
          const updatedItem = updateItems.find((rule) => rule.id === item.id);

          return updatedItem
            ? { ...item, ...updatedItem, version: (item.version ?? 0) + 1 }
            : item;
        });

      const nextIndex = fakeData.length + 1;
      const createdItems = createItems.map((item, index) => ({
        id: `acl-rule-${String(nextIndex + index).padStart(3, "0")}`,
        sequenceNo: 10 * (nextIndex + index),
        version: 1,
        ...item,
      }));

      fakeData = [...fakeData, ...createdItems];
      state.data = fakeData;
    },
  },
});

export const {
  setWiredIpv4AclData,
  updateWiredIpv4AclData,
} = wiredIpv4AclSlice.actions;

export default wiredIpv4AclSlice.reducer;
